import React from "react";
import { Hooks } from "@xt/xtbase";
const { useIntl } = Hooks;
import { Popover } from "antd";
import stylesInput from "../Input/index.module.less";
import stylesLess from "./index.module.less";
import { regexp } from "utils/method";
import XtInput from "components/Xt/Input";
import XtSvg from "components/Xt/Svg";

const PopoverContent = ({ value, minCount, regexpType, updateStatus }) => {
  const intl = useIntl();
  const pwdLengthGteX = intl.formatMessage(
    {
      id: "register.pwdLengthGteX"
    },
    {
      0: minCount
    }
  );
  const pwdErrorTip = intl.formatMessage({ id: "app.pwdErrorTip" }, { 0: minCount });

  const result = React.useMemo(() => {
    const lengthGteX = value && value.length >= minCount;
    const noSpace = value && !/\s/.test(value);
    const notAllChinese = value && !/^[\u4e00-\u9fa5]+$/.test(value);
    const regexPass = !regexpType || regexp(regexpType, value);

    return {
      lengthGteX,
      noSpace,
      notAllChinese,
      regexPass
    };
  }, [value, minCount, regexpType]);
  React.useEffect(() => {
    if (updateStatus) {
      if (!value) {
        updateStatus({ isOK: false, errMsg: "" });
      } else {
        if (regexpType && !regexp(regexpType, value)) {
          updateStatus({ isOK: false, errMsg: pwdErrorTip });
        } else {
          updateStatus({ isOK: true, errMsg: "" });
        }
      }
    }
  }, [value]);

  return (
    <div className={"iPopoverContent"}>
      <div>
        {result.lengthGteX ? <XtSvg icon={"correct"} /> : <i></i>}
        <div>{pwdLengthGteX}</div>
      </div>
      <div>
        {result.noSpace ? <XtSvg icon={"correct"} /> : <i></i>}
        <div>{intl.formatMessage({ id: "register.pwdNoSpace", defaultMessage: "No spaces allowed" })}</div>
      </div>
      <div>
        {result.notAllChinese ? <XtSvg icon={"correct"} /> : <i></i>}
        <div>{intl.formatMessage({ id: "register.pwdNotAllChinese", defaultMessage: "Cannot be all Chinese characters" })}</div>
      </div>
    </div>
  );
};

export default React.forwardRef(function FormItemPassword(props, ref) {
  const {
    isErr,
    allowSpace,
    popover = true,
    minCount = 8,
    regexpType = "loginPassword",
    autoComplete,
    updateStatus,
    value,
    disabled,
    onInput,
    onFocus,
    onBlur,
    style,
    ...rest
  } = props;

  const [state_isFocus, setState_isFocus] = React.useState(false);
  const [state_isEyeOpen, setState_isEyeOpen] = React.useState(false);

  const refInput = React.useRef();
  const anchorRef = React.useRef(null);

  const handleInputFocus = (e) => {
    // console.log("handleInputFocus", state);
    setState_isFocus(true);
    onFocus && onFocus(e);
  };
  const handleInputBlur = (e) => {
    // console.log("handleInputBlur", state);
    setState_isFocus(false);
    onBlur && onBlur(e);
  };
  const handleInputCopy = (e) => {
    // console.log(e.target.innerHTML);
    e.preventDefault();
    e.nativeEvent.stopImmediatePropagation();
  };

  const handleClear = () => {
    onInput && onInput("");
    refInput.current.focus();
  };
  const handleEyeToggle = () => {
    setState_isEyeOpen(!state_isEyeOpen);
    // refInput.current.focus();
  };

  const classList = [
    stylesInput.main,
    stylesLess.main
    // appState.isDark ? "dark" : "light",
  ];
  isErr && classList.push("err");
  state_isFocus && classList.push("atv");

  const ElMain = (
    <div className={`${classList.join(" ")}`} ref={anchorRef}>
      <XtInput
        ref={refInput}
        value={value}
        type={state_isEyeOpen ? "text" : "password"}
        autoComplete={autoComplete}
        style={style}
        maxLength="1000"
        disabled={disabled}
        onInput={(val) => (allowSpace ? onInput(val) : onInput(val.replace(/\s*/g, "")))}
        onFocus={handleInputFocus}
        onBlur={handleInputBlur}
        onCopy={handleInputCopy}
        {...rest}
      />
      {(value || value === 0) && (
        <button type="button" tabIndex={-1} className="btntxt ico" disabled={disabled} onClick={handleClear}>
          <XtSvg icon={"error"} />
        </button>
      )}
      <button type="button" tabIndex={-1} className="btntxt ico" disabled={disabled} onClick={handleEyeToggle}>
        <XtSvg icon={state_isEyeOpen ? "eye-on" : "eye-off"} />
      </button>
    </div>
  );

  React.useImperativeHandle(ref, () => ({
    inputEl: refInput.current
  }));

  return (
    <>
      {popover && (
        <Popover
          getPopupContainer={() => anchorRef.current}
          content={<PopoverContent value={value} minCount={minCount} regexpType={regexpType} updateStatus={updateStatus} />}
          placement="right"
          overlayClassName={"iPopover"}
          open={state_isFocus && !!refInput.current.value}
        >
          {ElMain}
        </Popover>
      )}
      {!popover && ElMain}
    </>
  );
});
